export const TaskCenterAssetSlugs = Object.freeze({
  TASK_CENTER_CARD_STAFF_IMAGE: 'lsFkztozbGf1gkJAYeT9k',
  TASK_CENTER_CARD_AUDIT_IMAGE: '54f2PalmzWp2SCIAl3GVyF',
  TASK_CENTER_CARD_HR_PRACTICES_IMAGE: '3rx8xl9aXX2HP2YxxKn4JR',
  TASK_CENTER_CARD_EMPLOYEE_VOICES: '6600b4SXZsfiPiXAL9zXR8',
});

export default TaskCenterAssetSlugs;
